<template>
  <div class="gb-page old-version-page">
    <HeadNav selectedLanguage="en" page="update" />
    <div class="content-rail">
      <BreadcrumbNav
        :items="[
          { label: 'Update', to: { name: 'en-update' } },
          { label: 'Old Version' },
        ]"
      />

      <main>
      <section class="old-hero">
        <div class="hero-bg" aria-hidden="true" />
        <div class="rail-inner">
          <p class="eyebrow">
            <span class="eyebrow-dot" />
            Version history
          </p>
          <h1>GB WhatsApp Old Version APK Download</h1>
        </div>
      </section>

      <section class="content-section intro-section">
        <div class="prose intro-panel">
          <p>
            This page lists previous
            <router-link class="home-text-link" :to="{ name: 'en-gb' }">
              GB WhatsApp
            </router-link>
            version numbers and explains what to check before installing an older
            APK. Availability depends on whether the corresponding installation
            file is still accessible.
          </p>
          <p>
            If you want the newest release instead, visit our
            <router-link class="home-text-link" :to="{ name: 'en-update' }">
              GB WhatsApp Update page
            </router-link>
            to check the latest version listed on this website.
          </p>
        </div>
      </section>

      <section class="content-section muted versions-section section-bleed">
        <div class="rail-inner">
          <p class="section-kicker">Earlier releases</p>
          <h2>Previous GB WhatsApp Versions</h2>
          <p class="section-lead">
            The version history below records earlier releases listed on this
            website. Historical entries help you identify version numbers, but
            they do not automatically mean that a verified download file is
            available for every release.
          </p>

          <div class="version-grid">
          <article class="version-block">
            <h3>GB WhatsApp v18.70</h3>
            <p>
              Version v18.70 is listed as an earlier release preceding v18.80 on
              this website. If you are looking for this version, check the APK's
              version information and source before downloading it.
            </p>
            <p>
              An older version may behave differently depending on your Android
              device, the app package, and the data carried over from your
              existing installation.
            </p>
            <ul class="version-meta">
              <li><strong>Version:</strong> v18.70</li>
              <li><strong>Status:</strong> Previous version</li>
              <li><strong>Platform:</strong> Android</li>
              <li>
                <strong>Download availability:</strong> Check whether a
                compatible APK is available before proceeding.
              </li>
            </ul>
          </article>

          <article class="version-block">
            <h3>GB WhatsApp v18.60</h3>
            <p>
              Version v18.60 is another earlier entry in the version history.
              It may be relevant if you are comparing release numbers or trying
              to identify an APK already saved on your phone.
            </p>
            <p>
              Do not assume that v18.60 contains a particular feature or fixes a
              specific issue unless you can confirm that information from reliable
              release details.
            </p>
            <ul class="version-meta">
              <li><strong>Version:</strong> v18.60</li>
              <li><strong>Status:</strong> Older version</li>
              <li><strong>Platform:</strong> Android</li>
              <li>
                <strong>Download availability:</strong> Check whether a
                compatible APK is available before proceeding.
              </li>
            </ul>
          </article>
          </div>
        </div>
      </section>

      <section class="content-section article-section">
        <div class="prose">
          <h2>Why Do People Look for Older GB WhatsApp Versions?</h2>
          <p>
            There are several reasons someone might prefer an earlier release,
            but choosing an older APK does not guarantee a better experience.
          </p>
          <p>
            <strong>An update caused a problem.</strong> If the app started
            crashing or behaving differently after an update, you may want to
            investigate whether the issue is related to the new version.
            However, crashes can also result from low storage, Android
            compatibility, or damaged app data.
          </p>
          <p>
            <strong>A familiar interface changed.</strong> Some users prefer the
            layout or settings they remember from an earlier release. Version
            numbers alone do not tell you exactly which interface changes
            occurred, so check reliable version information before making a
            decision.
          </p>
          <p>
            <strong>A device has compatibility issues.</strong> An older phone
            may behave differently with different app builds. Still, an older APK
            is not automatically more compatible or more stable.
          </p>
          <p>
            <strong>You need to identify an existing APK.</strong> If you have
            several GB WhatsApp installation files saved on your device, checking
            their version numbers can help you distinguish them before installing
            anything.
          </p>

          <h2>How to Check a GB WhatsApp APK Version</h2>
          <p>Before installing an older file, verify which version you actually have.</p>
          <ol>
            <li>
              If the app is already installed, open its settings and look for the
              version information.
            </li>
            <li>
              If you only have an APK file, check its details using a trusted
              file-management or APK inspection tool.
            </li>
            <li>Compare the displayed version number with the version stated on the download page.</li>
            <li>Check the package name and publisher information where available.</li>
            <li>Do not install the file if its origin or identity is unclear.</li>
          </ol>
          <p>
            A filename containing a version number is not proof that the APK really
            corresponds to that release. Be cautious of renamed files and download
            pages that provide no meaningful information about the file.
          </p>

          <h2>How to Install an Older GB WhatsApp Version</h2>
          <p>Installing an older version requires more care than simply opening an APK file.</p>
          <p>
            <strong>Back up important chats first.</strong> Preserve important
            conversations and media before making changes. Confirm that your
            backup exists and that you understand how the current app stores it.
          </p>
          <p>
            <strong>Check compatibility.</strong> Make sure the APK is intended for
            Android and that the package is compatible with your device. An older
            version may not work correctly on your current Android release.
          </p>
          <p>
            <strong>Understand the installation risks.</strong> Android may reject
            an APK because its signature differs from the installed app.
            Uninstalling the existing app to get around this can remove local
            data, so do not proceed without preserving anything important.
          </p>
          <p>
            <strong>Verify the installation.</strong> If you decide to proceed,
            check the installed version and confirm that your chats and media are
            available. Keep your backup until you are satisfied that the app is
            working as expected.
          </p>
          <p>
            GB WhatsApp is a third-party modification rather than an official
            WhatsApp release. Older builds may lack security fixes, may stop
            working correctly, and may carry account or privacy risks. Consider
            these trade-offs before choosing an older version.
          </p>

          <h2>Should You Use an Old Version or the Latest Update?</h2>
          <p>The right choice depends on your situation.</p>
          <p>
            If you simply want the latest version listed on this website, visit the
            <router-link class="home-text-link" :to="{ name: 'en-download' }">
              GB WhatsApp Download page
            </router-link>. It contains the current version information and update
            instructions.
          </p>
          <p>
            If you are troubleshooting a problem, first check storage space,
            Android compatibility, and whether the problem can be resolved
            without replacing the app. Moving to an older version is not a
            guaranteed fix, and restoring an old backup can affect newer chat
            history.
          </p>
          <p>
            If you still need a previous release, use only a file whose identity
            and source you can reasonably verify. Do not assume an old APK is safe
            just because its version number is familiar.
          </p>
        </div>
      </section>

      <section class="content-section muted faq-section section-bleed">
        <div class="rail-inner">
          <p class="section-kicker">Old version FAQ</p>
          <h2>Frequently Asked Questions</h2>
          <div class="faq-list">
            <details
              v-for="(faq, idx) in faqs"
              :key="faq[0]"
              class="faq-item"
              :open="idx === 0"
            >
              <summary>{{ faq[0] }}</summary>
              <p>{{ faq[1] }}</p>
            </details>
          </div>
        </div>
      </section>

      <section class="content-section closing-section">
        <div class="prose closing-panel">
          <h2>Final Thoughts</h2>
          <p>
            Older GB WhatsApp versions can be useful when you need to identify a
            previous release or investigate a compatibility issue. Before
            installing one, verify the APK, protect your chat data, and consider
            the risks of using outdated software. If you do not specifically need
            an earlier build, checking the latest
            <router-link class="home-text-link" :to="{ name: 'en-update' }">
              GB WhatsApp update
            </router-link>
            is the more straightforward starting point.
          </p>
        </div>
      </section>
      </main>
    </div>
  </div>
</template>

<script>
import HeadNav from '@/components/HeadNav.vue'
import BreadcrumbNav from '@/components/BreadcrumbNav.vue'
import { oldVersionFaqs } from '@/content/gbwapps'
import '@/css/base.scss'

export default {
  name: 'GbWhatsappOldVersionPage',
  components: {
    HeadNav,
    BreadcrumbNav,
  },
  data() {
    return {
      faqs: oldVersionFaqs,
    }
  },
}
</script>

<style lang="scss" scoped>
.gb-page {
  background: #ffffff;
  color: #111111;
  font-family: 'Lora', Georgia, serif;
  font-size: 16px;
  line-height: 1.65;
  -webkit-font-smoothing: antialiased;
  overflow-x: hidden;
}

.content-rail {
  width: min(1120px, calc(100% - 32px));
  margin: 0 auto;
}

.old-version-page ::v-deep .breadcrumb-nav {
  width: 100%;
  max-width: none;
  margin: 0;
}

.rail-inner {
  width: 100%;
  margin: 0 auto;
}

.section-bleed {
  width: 100vw;
  max-width: 100vw;
  margin-left: calc(50% - 50vw);
  margin-right: calc(50% - 50vw);
  box-sizing: border-box;
}

.section-bleed .rail-inner {
  width: min(1120px, calc(100% - 32px));
}

.old-hero {
  position: relative;
  width: 100vw;
  max-width: 100vw;
  margin-left: calc(50% - 50vw);
  margin-right: calc(50% - 50vw);
  padding: 52px 0 58px;
  border-bottom: 1px solid #dce9e2;
  overflow: hidden;
  box-sizing: border-box;
}

.hero-bg {
  position: absolute;
  inset: 0;
  background:
    radial-gradient(circle at 18% 20%, rgba(22, 163, 74, 0.16), transparent 34%),
    radial-gradient(circle at 88% 12%, rgba(16, 37, 28, 0.08), transparent 28%),
    linear-gradient(180deg, #eefaf2 0%, #ffffff 72%);
  pointer-events: none;
  z-index: 0;
}

.old-hero .rail-inner {
  position: relative;
  z-index: 1;
  width: min(1120px, calc(100% - 32px));
  margin: 0 auto;
}

.eyebrow {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  margin: 0 0 14px;
  color: #0f8f43;
  font-family: 'Oswald', Arial, sans-serif;
  font-size: 14px;
  font-weight: 400;
  text-transform: uppercase;
  letter-spacing: 0.04em;
}

.eyebrow-dot {
  width: 8px;
  height: 8px;
  border-radius: 50%;
  background: #16a34a;
}

h1,
h2,
h3 {
  margin: 0 0 14px;
  color: #000000;
  font-family: 'Oswald', Arial, sans-serif;
  font-weight: 400;
  letter-spacing: 0;
}

h1 {
  font-size: clamp(28px, 4vw, 34px);
  line-height: 1.2;
}

h2 {
  font-size: clamp(22px, 3vw, 24px);
  line-height: 1.25;
}

h3 {
  font-size: 18px;
  line-height: 1.3;
  padding-bottom: 10px;
  border-bottom: 1px solid #e5ece8;
}

p {
  color: #222222;
  line-height: 1.625;
}

.content-section {
  padding: 56px 0;
}

.muted {
  background: #f6faf8;
}

.intro-section {
  padding-top: 40px;
  padding-bottom: 48px;
}

.intro-panel {
  width: 100%;
  box-sizing: border-box;
  padding: 24px 26px;
  border: 1px solid #d7e8de;
  border-radius: 16px;
  background: linear-gradient(180deg, #ffffff 0%, #f7fcf9 100%);
  box-shadow: 0 12px 28px rgba(16, 37, 28, 0.05);
}

.section-kicker {
  margin: 0 0 8px;
  color: #0f8f43;
  font-family: 'Oswald', Arial, sans-serif;
  font-size: 13px;
  font-weight: 400;
  text-transform: uppercase;
  letter-spacing: 0.04em;
}

.section-lead {
  margin: 0 0 28px;
  color: #40554c;
  font-size: 17px;
  line-height: 1.6;
}

.prose {
  width: 100%;
}

.prose p,
.prose ol {
  max-width: none;
}

.prose p + p {
  margin-top: 14px;
}

.prose h2 {
  margin-top: 40px;
  padding-top: 8px;
}

.prose h2:first-child {
  margin-top: 0;
}

.prose p > strong:first-child {
  display: inline-block;
  margin-bottom: 4px;
  color: #10251c;
  font-family: 'Oswald', Arial, sans-serif;
  font-size: 15px;
  font-weight: 400;
  text-transform: uppercase;
  letter-spacing: 0.02em;
}

.prose ol {
  margin: 16px 0 0;
  padding: 20px 22px 20px 44px;
  border: 1px solid #d7e8de;
  border-radius: 14px;
  background: #ffffff;
  box-shadow: 0 10px 22px rgba(16, 37, 28, 0.04);
}

.prose ol li {
  margin-bottom: 10px;
  padding-left: 4px;
  color: #33443b;
}

.prose ol li:last-child {
  margin-bottom: 0;
}

.article-section {
  background:
    radial-gradient(circle at 12% 20%, rgba(22, 163, 74, 0.06), transparent 36%),
    linear-gradient(180deg, #ffffff 0%, #f9fcfa 100%);
}

.home-text-link {
  color: #0f8f43;
  text-decoration: underline;
  text-underline-offset: 2px;
}

.version-grid {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 18px;
  align-items: stretch;
}

.version-block {
  display: flex;
  flex-direction: column;
  height: 100%;
  padding: 22px 20px 20px;
  background: #ffffff;
  border: 1px solid #dce9e2;
  border-radius: 16px;
  box-shadow: 0 14px 30px rgba(16, 37, 28, 0.06);
  transition: border-color 0.2s ease, box-shadow 0.2s ease, transform 0.2s ease;

  p {
    margin: 0 0 12px;
    color: #40554c;
    font-size: 15px;
    line-height: 1.6;
  }

  p:last-of-type {
    flex: 1;
  }
}

.version-block:hover {
  transform: translateY(-2px);
  border-color: #98d0b2;
  box-shadow: 0 18px 34px rgba(16, 37, 28, 0.08);
}

.version-meta {
  margin: 8px 0 0;
  padding: 14px 14px 6px;
  list-style: none;
  border-top: 1px dashed #dce9e2;
  display: grid;
  gap: 10px;

  li {
    margin: 0;
    padding: 10px 12px;
    border-radius: 10px;
    background: #f6faf8;
    color: #294038;
    font-size: 14px;
    line-height: 1.5;
  }

  strong {
    color: #0f8f43;
    font-family: 'Oswald', Arial, sans-serif;
    font-size: 12px;
    font-weight: 400;
    text-transform: uppercase;
    letter-spacing: 0.03em;
  }
}

.faq-list {
  display: grid;
  gap: 12px;
  width: 100%;
}

.faq-item {
  border: 1px solid #dce9e2;
  border-radius: 12px;
  background: #ffffff;
  overflow: hidden;
}

.faq-item summary {
  list-style: none;
  cursor: pointer;
  padding: 18px 20px;
  color: #111111;
  font-family: 'Oswald', Arial, sans-serif;
  font-size: 17px;
  font-weight: 400;
  line-height: 1.35;
}

.faq-item summary::-webkit-details-marker {
  display: none;
}

.faq-item[open] summary {
  border-bottom: 1px solid #e5ece8;
  background: #f7fcf9;
}

.faq-item p {
  margin: 0;
  padding: 16px 20px 20px;
  color: #33443b;
}

.closing-panel {
  width: 100%;
  box-sizing: border-box;
  padding: 28px 30px;
  border: 1px solid #d7e8de;
  border-radius: 16px;
  background: linear-gradient(135deg, #f3fbf6 0%, #ffffff 55%);
  box-shadow: 0 12px 28px rgba(16, 37, 28, 0.05);
}

.closing-panel h2 {
  margin-bottom: 12px;
}

.closing-panel p {
  margin: 0;
  color: #33443b;
}

@media (max-width: 980px) {
  .version-grid {
    grid-template-columns: 1fr;
  }

  h1 {
    font-size: 28px;
  }

  .content-section {
    padding: 44px 0;
  }

  .intro-panel,
  .closing-panel {
    padding: 20px 18px;
  }
}
</style>
